module.exports = __webpack_public_path__ + "img/セミナー申し込み.881dd93d.png";